import React from 'react';
import styled from 'styled-components/macro';
import { Div } from '../../../../components/grid';

const StyledSidemenuSpacer = styled(Div)`
  height: 20px;
`;

export default () => (
  <StyledSidemenuSpacer />
);
